import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { BASE_URL, BASE_URL_PREBID } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { UpdatePencil, DropdownArrow, SearchBig, AddwithWhiteCircle } from "../AllSvg";
import { Modal } from 'react-bootstrap';
import Createnewall from "../Modals/Createnewall";
import { handleErrorToast } from "../CustomFunctions";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const exportToExcel = (data, fileName = 'ProjectData.xlsx') => {
  // Format data to be Excel-friendly
  const formattedData = data.map((item, index) => ({
    "Sr No": index + 1,
    "Project Name": item.project_name,
    "Project Code": item.project_code,
    "Description": item.project_description,
    "Weightage": "100%", // if static
    "Total Amount": item.woamount,
    "Client Name": item.clientname || "N/A",
    "Client POS": item.client_pos,
    "Award Date": item.wo_date,
    "Start Date": item.start_date,
    "Status": item.project_status,
  }));

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(dataBlob, fileName);
};

// import { AddProjectDetails } from "../Modals/UpdateProjectDetails";


const AddProjectDetails = ({ getDetailsdesign }) => {
  const [sub_CompanyList, setsub_CompanyList] = useState([]);
  const getAllsub_Company = async () => {

    try {
      const sub = await axios.get(`${BASE_URL}/detail-design/subCompany/`);
      setsub_CompanyList(sub.data);
    } catch (err) {

    } finally {

    }
  };
  const [projectList, setProjectlist] = useState([]);
  const [show, setShow] = useState(false);
  const [add_client, setAdd_client] = useState([]);
  const [formData, setFormData] = useState({
    project_code: '',
    project_description: '',
    project_name: '',
    sub_Company: '',
    clientname: '',
    // pos: '',
    client: '',
    location: '',
    concern_person: '',
    concern_person_name: '',
    length: '',
    // award_date: '',
    wo_date: '',
    start_date: '',
    due_date: '',
    project_mode: '',
    woamount: '',
    gst_amount: '',
    confirm_by: '',
    confirmation_mode: '',
    // status: 'pending',
    project_status: 'pending',

  });




  const [errors, setErrors] = useState({});

  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [

    ];

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      }
    });

    setErrors(newErrors);


    return Object.keys(newErrors).length === 0;
  };

  console.log(formData)

  console.log(errors)


  const getAddClient = async () => {

    try {
      const sub = await axios.get(`${BASE_URL}/detail-design/client/`);
      setAdd_client(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {

    }
  };
  useEffect(() => {
    if (show) {
      getAddClient(null);
    }
  }, [formData.client, show])



  const [clientData, setClientData] = useState([])


  const getAddClientData = async (id) => {

    try {
      const sub = await axios.get(`${BASE_URL}/detail-design/ClientNameFilter/${id}/`);
      console.log(sub.data, 'pos')
      setClientData(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {

    }
  };
  useEffect(() => {
    if (show && formData.client) {
      getAddClientData(formData.client);
    }
  }, [formData.client, show])





  useEffect(() => {
    const Data = add_client.find(i => i.id === formData.client);


    setFormData((prev) => ({
      ...prev,
      clientname: Data?.client_name_name,


    }))
  }, [formData.client, add_client])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const filteredFormData = Object.keys(formData).reduce((acc, key) => {
          if (formData[key] !== '') {
            acc[key] = formData[key];
          }
          return acc;
        }, {});
        let res = await axios.post(`${BASE_URL}/detail-design/project/`, filteredFormData, {
          headers: {
            'Content-Type': 'application/json',
            accept: "application/json",
          }
        })

        if (res.status === 200) {
          setShow(false);
          getDetailsdesign();
          setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
              acc[key] = "";
              return acc;
            }, {})
          );
          // window.location.reload();

        } else {

        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        // setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;


    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
    // Handle other fields (e.g., project_name, client, etc.) as usual
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  // get request Client Data
  useEffect(() => {
    if (show) {
      getClientDetails();
    }

  }, [show]);

  const [allClientData, setAllClientData] = useState([]);
  const getClientDetails = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL_PREBID}/detail-design/client/`,
      );
      setAllClientData(res.data);
    } catch (err) {
      //toast Logic
      alert(err)
    } finally {

    }

  }
  const handleShow = () => {
    setShow(true);
    getAllsub_Company();

  }

  const handleClose = () => {
    setShow(false);
    setFormData(() =>
      Object.keys(formData).reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {})
    );
  }

  const handleWOAmountChange = (e) => {
    const value = e.target.value;
    const gstRate = 0.18; // 18% GST

    const woamount = parseFloat(value) || 0;
    const gstAmount = (woamount * gstRate) + woamount;
    const totalAmount = woamount + gstAmount;

    setFormData((prevData) => ({
      ...prevData,
      woamount: value,
      gst_amount: gstAmount.toFixed(2),
      total_amount: totalAmount.toFixed(2),
    }));
  };




  return (
    <>
      <button
        title="Add project Details"
        className="common-button"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Add Project
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="Activity-model add-project-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add Project Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <form className="register-form">
            <div className='form-flex-wrap'>
              <div className="flex-column">
                <label className="form-labels">Project Code <span className="required">*</span></label>
                <input
                  type="text"
                  placeholder="Project code"
                  name="project_code"
                  value={formData.project_code}
                  onChange={handleInputChange}
                  className={`form-input input-form  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                />
                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
              </div>

              <div className="flex-column">
                <label className="form-labels">Project Description </label>
                <input
                  type="text"
                  placeholder="Project Description"
                  name="project_description"
                  value={formData.project_description}
                  onChange={handleInputChange}
                  className={`form-input input-form  ${errors.project_description ? 'error' : inputState.project_description ? 'success' : ''}`}
                />
                {errors.project_description && <span className="error-message">{errors.project_description}</span>}
              </div>

              <div className="flex-column">
                <label className="form-labels">Project Name <span className="required">*</span></label>
                <input
                  type="text"
                  placeholder="Project Name"
                  name="project_name"
                  value={formData.project_name}
                  onChange={handleInputChange}
                  className={`form-input input-form  ${errors.project_name ? 'error' : inputState.project_name ? 'success' : ''}`}
                />
                {errors.project_name && <span className="error-message">{errors.project_name}</span>}
              </div>
              {/* <div title="sub_Company" className="flex-column form-group-selectt">
                <label htmlFor="sub_Company" className="form-labels  font-weight500    font-size-subheading">
                  Sub Company <span className="required">*</span>
                </label>
                <br />
                {sub_CompanyList.length === 0 ?
                  <div className="form-loader form-loader-width">
                    <div className="bar-loader"></div>
                  </div> :
                  <>
                    <select
                      id="sub_Company"
                      name="sub_Company"
                      value={formData.sub_Company}
                      onChange={handleInputChange}
                      className={`form-input input-form  form-group-selection ${errors.sub_Company ? "error" : inputState.sub_Company ? "success" : ""
                        }`}
                    >
                      <option value="">{sub_CompanyList.length > 0 ? sub_CompanyList?.find(company => company.id === formData.sub_Company)?.company_title || "Select a Sub Company" : formData?.sub_Company_name}</option>
                      {sub_CompanyList?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>

                        <option value={i.id}>{i.title}</option>
                      </>))
                      }
                      <svg width="16" height="10" viewBox="0 0 16 10" fill="black" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="black" fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                      </svg>
                    </select>
                    <div className={`form-group-selection-arrow selection-arrow ${errors.client ? 'error-arrow' : ''}`}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                      </svg>
                    </div>
                    <div>
                      {errors.sub_Company && (
                        <span className="error-message font-size-text ">{errors.sub_Company}</span>
                      )}
                    </div></>}
              </div> */}


              <div title="client" className="flex-column form-group-selectt">
                <label htmlFor="client" className="form-labels  font-weight500    font-size-subheading">
                  Client Name <span className="required">*</span>
                </label>
                <br />
                <select
                  id="client"
                  placeholder="Client name"
                  name="client"
                  value={formData.client}
                  onChange={handleInputChange}
                  className={`form-inputt form-group-selection ${errors.client ? "error" : inputState.client ? "success" : ""
                    }`}
                >
                  <option value="">Select a Client Name</option>
                  {add_client
                    ?.sort((a, b) =>
                      a.title?.localeCompare(b.client_name_name, 'en', {
                        ignorePunctuation: true
                      })
                    ).map((i, index) => (
                      <option value={i.id}>{i.client_name_name}</option>
                    ))
                  }
                </select>
                <div>
                  {errors.client && (
                    <span className="error-message font-size-text ">
                      {errors.client}</span>
                  )}
                </div>
              </div>

              <div className="flex-column">
                <label className="form-labels">Location</label>
                <input
                  type="text"
                  placeholder="Location"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  className={`form-input input-form   ${errors.location ? 'error' : inputState.location ? 'success' : ''}`}
                />
                {errors.location && <span className="error-message">{errors.location}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Length</label>
                <input
                  type="text"
                  placeholder="Length"
                  name="length"
                  value={formData.length}
                  onChange={handleInputChange}
                  className={`form-input input-form  ${errors.length ? 'error' : inputState.length ? 'success' : ''}`}
                />
                {errors.length && <span className="error-message">{errors.length}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels">WO Amount</label>
                <input
                  type="number"
                  placeholder="Wo Amount"
                  name="woamount"
                  value={formData.woamount}
                  onChange={handleWOAmountChange}
                  className={`form-input input-form  ${errors.woamount ? 'error' : inputState.woamount ? 'success' : ''}`}
                />
                {errors.woamount && <span className="error-message">{errors.woamount}</span>}
              </div>

              <div className="flex-column">
                <label className="form-labels">GST Amount</label>
                <input
                  type="number"
                  placeholder="GST Amount"
                  name="gst_amount"
                  value={formData.gst_amount}
                  readOnly
                  className={`form-input input-form  ${errors.gst_amount ? 'error' : inputState.gst_amount ? 'success' : ''}`}
                />
                {errors.gst_amount && <span className="error-message">{errors.gst_amount}</span>}
              </div>


              <div className="flex-column">
                <label className="form-labels">Business Unit Head<span className="required">*</span></label>
                <input
                  type="text"
                  placeholder="Business Unit Head"
                  name="concern_person"
                  value={formData.concern_person}
                  onChange={handleInputChange}
                  className={`form-input input-form  ${errors.concern_person ? 'error' : inputState.concern_person ? 'success' : ''}`}
                />
                {errors.concern_person && <span className="error-message">{errors.concern_person}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Confirm By</label>
                <input
                  type="text"
                  placeholder="Cofirm By"
                  name="confirm_by"
                  value={formData.confirm_by}
                  onChange={handleInputChange}
                  className={`form-input input-form  ${errors.confirm_by ? 'error' : inputState.confirm_by ? 'success' : ''}`}
                />
                {errors.confirm_by && <span className="error-message">{errors.confirm_by}</span>}
              </div>

              <div className="flex-column">
                <label className="form-labels">  Confirmation Mode</label>
                <input
                  type="text"
                  placeholder="Confirmation mode"
                  name="confirmation_mode"
                  value={formData.confirmation_mode}
                  onChange={handleInputChange}
                  className={` input-form  ${errors.confirmation_mode ? 'error' : inputState.confirmation_mode ? 'success' : ''}`}
                />
                {errors.confirmation_mode && <span className="error-message">{errors.confirmation_mode}</span>}
              </div>
              {/* <div className="flex-column">
                <label className="form-labels">Award Date</label>
                <input
                  type="date"
                  name="award_date"
                  value={formData.award_date}
                  onChange={handleInputChange}
                  className={`  ${errors.award_date ? 'error' : inputState.award_date ? 'success' : ''}`}
                />
                {errors.award_date && <span className="error-message">{errors.award_date}</span>}
              </div> */}
              <div className="flex-column">
                <label className="form-labels">WO Date</label>
                <input
                  type="date"
                  name="wo_date"
                  value={formData.wo_date}
                  onChange={handleInputChange}
                  className={` input-form  ${errors.wo_date ? 'error' : inputState.wo_date ? 'success' : ''}`}
                />
                {errors.wo_date && <span className="error-message">{errors.wo_date}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Start Date</label>
                <input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleInputChange}
                  className={` input-form   ${errors.start_date ? 'error' : inputState.start_date ? 'success' : ''}`}
                />
                {errors.start_date && <span className="error-message">{errors.start_date}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Due Date</label>
                <input
                  type="date"
                  name="due_date"
                  value={formData.due_date}
                  onChange={handleInputChange}
                  className={` input-form  ${errors.due_date ? 'error' : inputState.due_date ? 'success' : ''}`}
                />
                {errors.due_date && <span className="error-message">{errors.due_date}</span>}
              </div>

              <div className="flex-column form-group-selectt">
                <label className="form-labels">Status:</label>
                <br />
                <select
                  name="project_status"
                  value={formData.project_status}
                  onChange={handleInputChange}
                  className={`form-input input-form  form-group-selection ${errors.project_status ? 'error' : inputState.project_status ? 'success' : ''}`}
                >
                  <option value="">Select a Status</option>
                  <option value="pending">Pending</option>
                  <option value="inprogress">In Progeress</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="completed">Completed</option>
                  <option value="hold">Hold</option>



                </select>
                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </div>
                {errors.status && (
                  <span className="error-message ">{errors.status}</span>
                )}

              </div>







            </div>


            <div className="button-models">
              <button onClick={handleSubmit} className="model-button model-button-submit">Submit</button>
            </div>

          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}



const Updateprojectdata = ({ i, getJobappdata }) => {
  const [show, setShow] = useState(false);
  const [add_client, setAdd_client] = useState([]);
  const [clientData, setClientData] = useState([])

  const [sub_CompanyList, setsub_CompanyList] = useState([]);
  const getAllsub_Company = async () => {

    try {
      const sub = await axios.get(`${BASE_URL}/detail-design/subCompany/`);
      setsub_CompanyList(sub.data);
    } catch (err) {

    } finally {

    }
  };



  const [formData, setFormData] = useState({
    project_code: '',
    sub_Company: '',
    client: "",
    project_name: "",
    location: "",
    concern_person_name: "",
    length: "",
    // award_date: "",
    wo_date: "",
    start_date: "",
    due_date: "",
    project_mode: "",
    confirm_by: "",
    confirmation_mode: "",
    status: "",
    project_description: '',
    project_status: '',

  });


  const getAddClient = async () => {

    try {
      const sub = await axios.get(`${BASE_URL}/detail-design/GetClientName/`);
      setAdd_client(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {

    }
  };
  useEffect(() => {
    if (show) {
      getAddClient(null);
    }
  }, [formData.clientname, show])

  const getAddClientData = async (id) => {

    try {
      const sub = await axios.get(`${BASE_URL}/detail-design/ClientNameFilter/${id}/`);
      console.log(sub.data, 'pos')
      setClientData(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {

    }
  };
  useEffect(() => {
    if (show && formData.clientname) {
      getAddClientData(formData.clientname);
    }
  }, [formData.clientname, show])

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setFormData(i);
    getAllsub_Company();

  };
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      'project_name',
      'project_code',
      'client',
      // "sub_Company",
      "concern_person",
    ];

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      }
    });

    setErrors(newErrors);


    return Object.keys(newErrors).length === 0;
  };
  const [allClientData, setAllClientData] = useState([]);
  useEffect(() => {
    getClientDetails();
  }, []);
  const getClientDetails = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL_PREBID}/detail-design/client`,
      );
      setAllClientData(res.data);
    } catch (err) {

    } finally {

    }

  }
  console.log(formData)

  console.log(errors)

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('u7w5j56n5y55w5u7w5wu7')
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const filteredFormData = Object.keys(formData).reduce((acc, key) => {
          if (formData[key] !== '') {
            acc[key] = formData[key];
          }
          return acc;
        }, {});
        console.log({ filteredFormData, formData })
        let res = await axios.put(`${BASE_URL}/detail-design/projectupdate/${formData.id}/`, filteredFormData, {
          headers: {
            'Content-Type': 'application/json',
            accept: "application/json",
          }
        })

        if (res.status === 200) {

          setShow(false)
          await getJobappdata("null");
        } else {
          ;
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        // setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
    // Handle other fields (e.g., project_name, client, etc.) as usual
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <>

      <button title="Edite" onClick={handleShow} className="model-edit-button">
        {/* <UpdatePencilWhite /> */}
        <UpdatePencil />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="Activity-model add-project-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Update All Projects Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {console.log(formData)}
          <form className="register-form">
            <div className='form-flex-wrap'>
              <div className="flex-column">
                <label className="form-labels">Project Code <span className="required">*</span></label>
                <input
                  type="text"
                  name="project_code"
                  value={formData.project_code}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                />
                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels">Project Description </label>
                <input
                  type="text"
                  name="project_description"
                  value={formData.project_description}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.project_description ? 'error' : inputState.project_description ? 'success' : ''}`}
                />
                {errors.project_description && <span className="error-message">{errors.project_description}</span>}
              </div>

              <div className="flex-column">
                <label className="form-labels">Project Name <span className="required">*</span></label>
                <input
                  type="text"
                  name="project_name"
                  value={formData.project_name}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.project_name ? 'error' : inputState.project_name ? 'success' : ''}`}
                />
                {errors.project_name && <span className="error-message">{errors.project_name}</span>}
              </div>

              <div title="clientname" className="flex-column form-group-selectt">
                <label htmlFor="clientname" className="form-labels  font-weight500    font-size-subheading">
                  Client Name <span className="required">*</span>
                </label>
                <br />
                <select
                  id="clientname"
                  name="clientname"
                  value={formData.clientname}
                  onChange={handleInputChange}
                  className={`form-inputt form-group-selection ${errors.clientname ? "error" : inputState.clientname ? "success" : ""
                    }`}
                >
                  <option value="">Select a Client Name</option>
                  {add_client?.sort((a, b) => a.title?.localeCompare(b.clientname, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                    {console.log(i)}
                    <option value={i.id}>{i.clientname}</option>
                  </>))
                  }
                </select>
                <DropdownArrow />
                <div>
                  {errors.clientname && (
                    <span className="error-message font-size-text ">{errors.clientname}</span>
                  )}
                </div>
              </div>

              {/* <div className="flex-column form-group-selectt">
                <label className="form-labels"> Client POS<span className="required">*</span></label>
                <br />
                {allClientData.length === 0 ?
                  <div className="form-loader ">
                    <div className="bar-loader"></div>
                  </div> : <>
                    <select
                      name="client"
                      value={formData.client}
                      onChange={handleInputChange}
                      className={`form-input input-form  form-group-selection  ${errors.client ? 'error' : inputState.client ? 'success' : ''}`}
                    >
                      <option value="">Select a Client</option>
                      {
                        allClientData.length > 0 ?
                          (clientData.map((e, index) => (
                            <option key={index} value={e.id}>{e.gstin_number} - {e.pos}</option>
                          ))) : (
                            <option value="">No Clients Available</option>
                          )
                      }

                    </select>
                    <div className={`form-group-selection-arrow selection-arrow ${errors.client ? 'error-arrow' : ''}`}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                      </svg>
                    </div>
                    <br />
                    {errors.client && (
                      <span className="error-message">{errors.client}</span>
                    )}
                  </>}
              </div> */}

              <div className="flex-column">
                <label className="form-labels">Location</label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.location ? 'error' : inputState.location ? 'success' : ''}`}
                />
                {errors.location && <span className="error-message">{errors.location}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Length</label>
                <input
                  type="text"
                  name="length"
                  value={formData.length}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.length ? 'error' : inputState.length ? 'success' : ''}`}
                />
                {errors.length && <span className="error-message">{errors.length}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels">WO Amount</label>
                <input
                  type="number"
                  name="wo_date"
                  value={formData.wo_date}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.wo_date ? 'error' : inputState.wo_date ? 'success' : ''}`}
                />
                {errors.wo_date && <span className="error-message">{errors.wo_date}</span>}
              </div>
              {/* <div className="flex-column">
                <label className="form-labels">Without GST Amount</label>
                <input
                  type="number"
                  name="without_gst_amount"
                  value={formData.without_gst_amount}
                  onChange={handleInputChange}
                  className={`form-input  ${errors.without_gst_amount ? 'error' : inputState.without_gst_amount ? 'success' : ''}`}
                />
                {errors.without_gst_amount && <span className="error-message">{errors.without_gst_amount}</span>}
              </div> */}
              <div className="flex-column">
                <label className="form-labels"> GST Amount</label>
                <input
                  type="numbeer"
                  name="gst_amount"
                  value={formData.gst_amount}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.gst_amount ? 'error' : inputState.gst_amount ? 'success' : ''}`}
                />
                {errors.gst_amount && <span className="error-message">{errors.gst_amount}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels">Project Mode</label>
                <input
                  type="text"
                  name="project_mode"
                  value={formData.project_mode}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.project_mode ? 'error' : inputState.project_mode ? 'success' : ''}`}
                />
                {errors.project_mode && <span className="error-message">{errors.project_mode}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels">Business Unit Head <span className="required">*</span></label>
                <input
                  type="text"
                  name="concern_person"
                  value={formData.concern_person}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.concern_person ? 'error' : inputState.concern_person ? 'success' : ''}`}
                />
                {errors.concern_person && <span className="error-message">{errors.concern_person}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Confirm By</label>
                <input
                  type="text"
                  name="confirm_by"
                  value={formData.confirm_by}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.confirm_by ? 'error' : inputState.confirm_by ? 'success' : ''}`}
                />
                {errors.confirm_by && <span className="error-message">{errors.confirm_by}</span>}
              </div>

              <div className="flex-column">
                <label className="form-labels">  Confirmation Mode</label>
                <input
                  type="text"
                  name="confirmation_mode"
                  value={formData.confirmation_mode}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.confirmation_mode ? 'error' : inputState.confirmation_mode ? 'success' : ''}`}
                />
                {errors.confirmation_mode && <span className="error-message">{errors.confirmation_mode}</span>}
              </div>
              {/* <div className="flex-column">
                <label className="form-labels">Award Date</label>
                <input
                  type="date"
                  name="award_date"
                  value={formData.award_date}
                  onChange={handleInputChange}
                  className={`form-input  ${errors.award_date ? 'error' : inputState.award_date ? 'success' : ''}`}
                />
                {errors.award_date && <span className="error-message">{errors.award_date}</span>}
              </div> */}
              <div className="flex-column">
                <label className="form-labels">WO Date</label>
                <input
                  type="date"
                  name="wo_date"
                  value={formData.wo_date}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.wo_date ? 'error' : inputState.wo_date ? 'success' : ''}`}
                />
                {errors.wo_date && <span className="error-message">{errors.wo_date}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Start Date</label>
                <input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.start_date ? 'error' : inputState.start_date ? 'success' : ''}`}
                />
                {errors.start_date && <span className="error-message">{errors.start_date}</span>}
              </div>
              <div className="flex-column">
                <label className="form-labels"> Due Date</label>
                <input
                  type="date"
                  name="due_date"
                  value={formData.due_date}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.due_date ? 'error' : inputState.due_date ? 'success' : ''}`}
                />
                {errors.due_date && <span className="error-message">{errors.due_date}</span>}
              </div>

              <div className="flex-column form-group-selectt">
                <label className="form-labels">Status:</label>
                <br />
                <select
                  name="project_status"
                  value={formData.project_status}
                  onChange={handleInputChange}
                  className={`form-input  form-group-selection ${errors.project_status ? 'error' : inputState.project_status ? 'success' : ''}`}
                >
                  <option value="">Select a Status</option>
                  <option value="pending">Pending</option>
                  <option value="inprogress">In Progeress</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="completed">Completed</option>
                  <option value="hold">Hold</option>
                  <option value="cancelled">Cancelled</option>


                </select>
                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </div>
                {errors.status && (
                  <span className="error-message ">{errors.status}</span>
                )}

              </div>







            </div>


            <div className="button-models">
              <button onClick={handleSubmit} className="model-button model-button-submit">Submit</button>
            </div>
          </form>
        </Modal.Body>
      </Modal >

    </>
  );
};

const DetailsdesignDelete = ({ i, getJobappdata }) => {
  const [show, setShow] = useState(false);
  // console.log(i)
  const handleClose = () => setShow(false);
  const handleShow = () => {
    console.log('clicked ')
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(
        `${BASE_URL}/detail-design/projectupdate/${i.id}/`
      );

      if (res.status === 200) {
        await getJobappdata(null);
        setShow(false);
      } else {
        ;
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      // setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>

      <button
        title="Delete"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>


      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="Activity-Model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Project {i.project_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are you sure You want to delete this project{i.project_name}
            <div className="button-models">
              <button
                className="model-button   font-weight500  model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

const BulkUploadProject = ({ id, getProject }) => {

  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null);
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const bulktableRef = useRef(null);

  const handleDownload = () => {
    const table = bulktableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Project Details" });
    const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.ms-excel",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Project Detail Format.xls";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    setFileName("")
    setExcelJson(null)
    setDocErrors({})
    setShow(false)
  };
  const handleShow = () => setShow(true);

  // Function to handle file change

  const handleErrorToast = (err) => {
    let messages = err?.response?.data || "Something went wrong";

    // Normalize into array
    if (typeof messages === "string") {
      messages = [messages];
    } else if (typeof messages === "object" && !Array.isArray(messages)) {
      // If it's an object (like {field: ["error1", "error2"]})
      messages = Object.values(messages).flat();
    }

    // Now safe to loop
    messages.forEach((msg) => {
      toast.error(msg, { autoClose: 5000 });
    });
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check for valid file type
      const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file); // Convert the file to JSON
    } else {
      setFileName("");
    }
  };

  const checkForDuplicates = (data) => {
    const sitecodes = new Map();
    const duplicates = [];

    // Track positions of each insurance number
    data.forEach((i, index) => {
      const projectcode = i.site_prcode;
      if (sitecodes.has(projectcode)) {
        sitecodes.get(projectcode).push(index + 1); // index + 1 for 1-based position
      } else {
        sitecodes.set(projectcode, [index + 1]);
      }
    });

    // Now, filter out only the numbers that appear more than once
    sitecodes.forEach((positions, projectcode) => {
      if (positions.length > 1) {
        duplicates.push(`\Site Project Code :${projectcode} is found in position(s) ${positions.join(", ")}`);
      }
    });

    return duplicates;
  };

  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0]; // Use the first sheet
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

      const headers = json[0];
      const rows = json
        .slice(1) // skip header
        .filter(row => row.some(cell => cell !== null && cell !== "")); // keep only rows with at least 1 value

      console.log(headers);
      console.log(rows);


      const convertToYYYYMMDD = (input) => {
        try {
          let date;

          // Handle Excel serial dates
          if (typeof input === "number") {
            const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
            const daysOffset = input - 1; // Subtract 1 because of leap year bug
            date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
          } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
            // Format: YYYY.MM.DD
            const [year, month, day] = input.split('.');
            date = new Date(`${year}-${month}-${day}`);
          } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
            // Format: DD.MM.YYYY
            const [day, month, year] = input.split('.');
            date = new Date(`${year}-${month}-${day}`);
          } else {
            // Default parsing for other formats
            date = new Date(input);
          }

          if (isNaN(date.getTime())) {
            throw new Error('Invalid date format');
          }

          // Format the date as YYYY-MM-DD
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
          const day = String(date.getDate()).padStart(2, '0');

          return `${year}-${month}-${day}`;
        } catch (error) {
          return null; // Return null for invalid dates
        }
      };

      // // Create a formatted JSON object based on headers and row values
      // const formattedJson = rows.map((row) => {
      //     const obj = {};
      //     headers.forEach((header, index) => {
      //         if (["bid_tender_date", "portal_submission_date", "opening_date"].includes(header) && row[index] && typeof row[index] === "number") {
      //             obj[header] = convertToYYYYMMDD(row[index]); // Convert date
      //         } else {
      //             obj[header] = row[index] !== undefined ? row[index] : null;
      //         }
      //     });
      //     return obj;
      // });

      function convertToDDMMYYYY(dateValue) {
        if (!dateValue) return null;

        // Case 1: Excel serial number (e.g., 45123)
        if (typeof dateValue === "number") {
          const excelEpoch = new Date(1899, 11, 30); // Excel counts from 30-Dec-1899
          const date = new Date(excelEpoch.getTime() + dateValue * 86400000);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }

        // Case 2: Already a Date object
        if (dateValue instanceof Date && !isNaN(dateValue)) {
          const day = String(dateValue.getDate()).padStart(2, "0");
          const month = String(dateValue.getMonth() + 1).padStart(2, "0");
          const year = dateValue.getFullYear();
          return `${day}-${month}-${year}`;
        }

        // Case 3: String
        const str = String(dateValue).trim();

        // Try DD-MM-YYYY or DD/MM/YYYY
        const match = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{2,4})$/);
        if (match) {
          const day = match[1].padStart(2, "0");
          const month = match[2].padStart(2, "0");
          let year = match[3];
          if (year.length === 2) year = "20" + year; // handle YY
          return `${day}-${month}-${year}`;
        }

        // Fallback: try native Date
        const date = new Date(str);
        if (!isNaN(date)) {
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }

        return null;
      }



      const formattedJson = rows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          if (["wo_date", "start_date", "due_date"].includes(header) && row[index]) {
            obj[header] = convertToDDMMYYYY(row[index]);
          } else if (header === "assignedto" && row[index]) {
            try {
              obj[header] = JSON.parse(row[index]);
              console.log("obj[header]", obj[header]);
            } catch (err) {
              console.error(`Invalid format in assignedto: ${row[index]}`);
              obj[header] = [];
            }
          } else {
            obj[header] = row[index] !== undefined ? row[index] : null;
          }
        });
        return obj;
      });





      // Ensure the input to checkForDuplicates is an array
      const duplicates = checkForDuplicates(formattedJson);

      console.log("duplicates")
      console.log(duplicates)

      if (duplicates.length > 0) {
        // Toast notification with line breaks for each duplicate
        toast.error(
          `Duplicate Projects found:\n${duplicates.join("\n")}`,
          {
            autoClose: 5000, // Close toast after 5 seconds
          }
        );
      }
      // Set the formatted JSON data to state
      setExcelJson(formattedJson);
    };
    reader.readAsArrayBuffer(file);
    console.log("excelJson")
    console.log(excelJson)
  };

  // Function to handle the upload button click
  const handleUpload = async () => {

    if (excelJson) {
      const duplicates = checkForDuplicates(excelJson);

      if (duplicates.length > 0) {
        toast.error(`Duplicate Data found:\n ${duplicates.join(", ")}`, {
          autoClose: 5000,
        });
      }
      const loadingToastId = toast.loading("Uploading: Please wait...");
      try {
        const res = await axios.post(`${BASE_URL}/detail-design/uploadprojectsbulk/`, excelJson);
        if (res.status === 201) {
          await getProject(null);
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Projects uploaded successfully.");

        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add data!");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    } else {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
    }
  };

  const handleFileClear = () => {
    setFileName("")
    setExcelJson(null)
    setDocErrors({})
  };





  return (
    <>

      <button title="Bulk Upload Projects" className="model-button01 model-button-print01" onClick={handleShow} >
        {/* <UploadIcon /> */}
        {" "}Upload Projects
      </button>

      <Modal show={show} dialogClassName="ourcompany-model">
        <Modal.Body>
          <div className="flex-row align-center">
            <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Project Data in format :</Modal.Title> </h1>

            <button onClick={handleDownload} className="model-button-download model-button font-weight500">
              {/* <DownloadIcon /> */}
              {"  "} Format
            </button>
          </div>
          <div className="table-css-white-background" style={{ display: "none" }}>
            <table ref={bulktableRef} className="nested-table-lightblue">
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="align-left">project_name</th>
                  <th className="table-heading-text">project_code</th>
                  <th className="table-heading-text">project_description</th>
                  <th className="table-heading-text">length</th>
                  <th className="table-heading-text">waitage</th>
                  <th className="table-heading-text">woamount</th>
                  <th className="table-heading-text">gst_amount</th>
                  <th className="table-heading-text">clientname</th>
                  <th className="table-heading-text">location</th>
                  <th className="table-heading-text">concern_person</th>
                  <th className="table-heading-text">wo_date</th>
                  <th className="table-heading-text">start_date</th>
                  <th className="table-heading-text">due_date</th>
                  <th className="table-heading-text">confirm_by</th>
                  <th className="table-heading-text">confirmation_mode</th>
                  <th className="table-heading-text">project_status</th>

                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="align-left">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>

                </tr>
              </tbody>
            </table>
          </div>

          <div className=""
          >
            <div className="table-container scrollbar" style={{ width: "100%", marginTop: "20px" }}>
              <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                <thead className="table-heading">
                  <tr className="custom-table-head-tr modal-padding-heading">
                    <th className="table-heading-text">S. No.</th>
                    <th className="table-heading-text">Project Name</th>
                    <th className="table-heading-text">Project Code</th>
                    <th className="table-heading-text">Project Description</th>
                    <th className="table-heading-text">Length</th>
                    <th className="table-heading-text">Waitage</th>
                    <th className="table-heading-text">WO Amount</th>
                    <th className="table-heading-text">GST Amount</th>
                    <th className="table-heading-text">Client Name</th>
                    <th className="table-heading-text">location</th>
                    <th className="table-heading-text">Concern Person</th>
                    <th className="table-heading-text">WO Date</th>
                    <th className="table-heading-text">Start Date</th>
                    <th className="table-heading-text">Due Date</th>
                    <th className="table-heading-text">Confirm By</th>
                    <th className="table-heading-text">Confirmation Mode</th>
                    <th className="table-heading-text">Project Status</th>

                  </tr>
                </thead>
                <tbody>
                  {excelJson?.map((project, index) => (
                    <tr key={index} className="modal-padding-heading">
                      <td className="table-heading-text">{index + 1}</td>
                      <td className="table-heading-text">{project.project_name}</td>
                      <td className="table-heading-text">{project.project_code}</td>
                      <td className="table-heading-text">{project.project_description}</td>
                      <th className="table-heading-text">{project.length}</th>
                      <td className="table-heading-text">{project.waitage}</td>
                      <td className="table-heading-text">{project.woamount}</td>
                      <td className="table-heading-text">{project.gst_amount}</td>
                      <td className="table-heading-text">{project.clientname}</td>
                      <td className="table-heading-text">{project.location}</td>
                      <td className="table-heading-text">{project.concern_person}</td>
                      <td className="table-heading-text">{project.wo_date}</td>
                      <td className="table-heading-text">{project.start_date}</td>
                      <td className="table-heading-text">{project.due_date}</td>
                      <td className="table-heading-text">{project.confirm_by}</td>
                      <td className="table-heading-text">{project.confirmation_mode}</td>
                      <td className="table-heading-text">{project.project_status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex-column field-cont-div">
            <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
              Upload File
            </label>
            <label
              htmlFor="document_file"
              className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                }`}
            >
              <svg
                className="pdf-input"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
              style={{ display: "none", position: "relative" }}
            />
            {fileName && <p className="file-name align-center">{fileName}</p>}
            <br />
            {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
            {excelJson ? (<span className="file-clear" onClick={() => handleFileClear()}>
              Clear
            </span>) : null}
          </div>
          {/* 
                    <h4>References:</h4>
                    <div className="reference-container">
                        <div className="reference-section">
                            <p className="reference-title">General:</p>
                            <ul className="arrow-list">
                                <li>Prebid PR Code(prebid_prcode) should be unique</li>
                                <li>For Assigned To(assignedto) give data in format : {`["<emp_code1>","<emp_code2>"]`}</li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Contract Mode use one of these:</p>
                            <ul className="arrow-list">
                                <li>epc</li>
                                <li>ham</li>
                                <li>bot</li>
                            </ul>
                        </div>
                        <div className="reference-section">
                            <p className="reference-title">For Priority use one of these:</p>
                            <ul className="arrow-list">
                                <li>low</li>
                                <li>medium</li>
                                <li>high</li>
                            </ul>
                        </div>

                        <div className="date-section">
                            <p className="date-text">All Dates should be in DD-MM-YYYY format</p>
                        </div>
                    </div> */}


          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>
            <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
              {/* <UploadIcon /> */}
              {"  "} Upload
            </button>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};


const AllProjectDetails = () => {
  const location = useLocation();
  const [allClientsData, setAllClientsData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [search1, setSearch1] = useState("");
  const [search2, setSearch2] = useState("");
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [toggleState, setToggleState] = useState(
    location.state?.status || "null"
  );


  const getProjectdata = async (toggleState) => {
    setBuffering(true); // Start Buffering
    try {

      const res = await axios.get(`${BASE_URL}/detail-design/allprojectfilter/${toggleState}/`);
      console.log(res.data)
      setAllClientsData(res.data);
      setFilteredData(res.data);
    } catch (err) {
      // alert(err.message);

      //toast Logic
      if (err.response) {
        const errorData = err.response.data;

        if (typeof errorData.error === 'string') {
          // Single error message
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          // Multiple error messages
          Object.entries(errorData).forEach(([field, messages]) => {
            messages?.forEach(message => toast?.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getProjectdata(toggleState);
  }, [toggleState]);

  const handleSearch = () => {
    let filteredingData = allClientsData;

    if (search1 !== "") {
      const lowercasesearch1 = search1?.toLowerCase();

      filteredingData = filteredData.filter(
        (employee) => {
          const projectMatch = employee?.project_name
            ?.toLowerCase()
            .includes(lowercasesearch1) || employee?.project_code
              ?.toLowerCase()
              .includes(lowercasesearch1) || employee?.clientname
                ?.toLowerCase()
                .includes(lowercasesearch1) || employee?.employee
                  ?.toLowerCase()
                  .includes(lowercasesearch1)

          return projectMatch;
        }
      );

    }



    setFilteredData(filteredingData);
  };

  useEffect(() => {
    handleSearch();
  }, [search1]);

  useEffect(() => {
    getEmployeeDetails();
  }, []);

  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const getEmployeeDetails = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanysdep/${sessionStorage.getItem(
          "departmentid"
        )}/`
      );
      setAllEmployeeData(res.data);
    } catch (err) {
      alert(err.message);
    }
  };

  const [initiated, setInitiated] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };




  const navigate = useNavigate();

  const getProjectdetails = (id) => {

    if (sessionStorage.getItem("role") === "ReportingHead") {
      navigate(`/rh/Projectdetails/`, {
        state: { projectId: id }
      });
    } else {
      navigate(`/ed/Projectdetails/`, {
        state: { projectId: id }
      });
    }
  };

  const [searchTerm, setSearchTerm] = useState('');

  const [menuopen, setMenuopen] = useState(false);
  const [menuopenrecieve, setMenuopenrecieve] = useState(false);
  const [menuopenstart, setMenuopenstart] = useState(false);
  const [menuIndex, setMenuIndex] = useState(null);
  const toggleMenu = (index) => {
    setMenuopen(!menuopen);
    setMenuIndex(index)
  };

  const toggleMenurecieve = (index) => {
    setMenuopenrecieve(!menuopen);

  };

  const toggleMenustart = (index) => {
    setMenuopenstart(!menuopen);

  };
  const menuRef = useRef(null);
  const menuRefrecieve = useRef(null);
  const menuRefstart = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRefrecieve.current && !menuRefrecieve.current.contains(event.target)) {
        setMenuopenrecieve(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRefstart.current && !menuRefstart.current.contains(event.target)) {
        setMenuopenstart(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const [sortConfig, setSortConfig] = useState({
    awardDate: null,
    startDate: null
  });

  const toggleAwardDateSort = () => {
    setSortConfig(prev => {
      if (prev.awardDate === null || prev.awardDate === 'desc') {
        return { ...prev, awardDate: 'asc', startDate: null };
      } else {
        return { ...prev, awardDate: 'desc', startDate: null };
      }
    });
  };

  const toggleStartDateSort = () => {
    setSortConfig(prev => {
      if (prev.startDate === null || prev.startDate === 'desc') {
        return { ...prev, startDate: 'asc', awardDate: null };
      } else {
        return { ...prev, startDate: 'desc', awardDate: null };
      }
    });
  };

  // const sortedData = [...filteredData].sort((a, b) => {
  //   if (sortConfig.awardDate) {
  //     const dateA = new Date(a.wo_date);
  //     const dateB = new Date(b.wo_date);
  //     return sortConfig.awardDate === 'asc' ? dateA - dateB : dateB - dateA;
  //   } else if (sortConfig.startDate) {
  //     const dateA = new Date(a.start_date);
  //     const dateB = new Date(b.start_date);
  //     return sortConfig.startDate === 'asc' ? dateA - dateB : dateB - dateA;
  //   }
  //   // return 0;
  // });
  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);



  const [activeStatus, setActiveStatus] = useState('allproject');

  const handleBoxClick = (status) => {
    setActiveStatus(status);
  };

  const statuses = ['allproject', 'completed', 'pending', 'hold', 'cancelled'];



  const exportToExcel = (data, fileName = 'ProjectData.xlsx') => {

    const formattedData = data.map((item, index) => ({
      "Sr No": index + 1,
      "Project Name": item.project_name,
      "Project Code": item.project_code,
      "Description": item.project_description,
      "Weightage": "100%", // if static
      "Total Amount": item.woamount,
      "GST Amount": item.gst_amount,
      "Client Name": item.clientname || "N/A",
      "Client POS": item.client_pos,
      "Award Date": item.wo_date,
      "Start Date": item.start_date,
      "Status": item.project_status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(dataBlob, fileName);
  };

  // ****************************  Date Filter **********************************************

  console.log(filteredData, 'filterdtaa')



  return (
    <>
      <Dashboardnavbar url="All Projects" name={"All Projects"} />

      <div className="content-tabs">


        <div className="filters-wrapper">
          <div className="filters-label "><svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 8.99954H6.64676M2.63935 8.99954H1M2.63935 8.99954C2.63935 8.47319 2.85041 7.96839 3.22609 7.59619C3.60177 7.224 4.1113 7.01491 4.64259 7.01491C5.17389 7.01491 5.68342 7.224 6.0591 7.59619C6.43478 7.96839 6.64584 8.47319 6.64584 8.99954C6.64584 9.5259 6.43478 10.0307 6.0591 10.4029C5.68342 10.7751 5.17389 10.9842 4.64259 10.9842C4.1113 10.9842 3.60177 10.7751 3.22609 10.4029C2.85041 10.0307 2.63935 9.5259 2.63935 8.99954ZM18 15.0145H12.7181M12.7181 15.0145C12.7181 15.5409 12.5065 16.0463 12.1307 16.4186C11.755 16.7909 11.2453 17 10.7139 17C10.1826 17 9.67307 16.79 9.29739 16.4178C8.9217 16.0456 8.71065 15.5408 8.71065 15.0145M12.7181 15.0145C12.7181 14.488 12.5065 13.9835 12.1307 13.6112C11.755 13.239 11.2453 13.0298 10.7139 13.0298C10.1826 13.0298 9.67307 13.2389 9.29739 13.6111C8.9217 13.9833 8.71065 14.4881 8.71065 15.0145M8.71065 15.0145H1M18 2.98464H15.1468M11.1394 2.98464H1M11.1394 2.98464C11.1394 2.45828 11.3504 1.95348 11.7261 1.58129C12.1018 1.2091 12.6113 1 13.1426 1C13.4057 1 13.6662 1.05133 13.9092 1.15107C14.1522 1.25081 14.3731 1.397 14.5591 1.58129C14.7451 1.76558 14.8927 1.98436 14.9934 2.22515C15.094 2.46594 15.1458 2.72401 15.1458 2.98464C15.1458 3.24526 15.094 3.50334 14.9934 3.74413C14.8927 3.98491 14.7451 4.2037 14.5591 4.38799C14.3731 4.57228 14.1522 4.71847 13.9092 4.8182C13.6662 4.91794 13.4057 4.96927 13.1426 4.96927C12.6113 4.96927 12.1018 4.76018 11.7261 4.38799C11.3504 4.0158 11.1394 3.511 11.1394 2.98464Z" stroke="#2576BC" stroke-miterlimit="10" stroke-linecap="round" />
          </svg> <span className="underline"> Filters:</span></div>
          <div className="search-container">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path stroke="#d1d5db" d="M13 13L9.96257 9.96257M9.96257 9.96257C10.4501 9.47505 10.8368 8.89627 11.1007 8.2593C11.3645 7.62232 11.5003 6.93961 11.5003 6.25015C11.5003 5.56069 11.3645 4.87798 11.1007 4.24101C10.8368 3.60403 10.4501 3.02526 9.96257 2.53773C9.47505 2.05021 8.89627 1.66349 8.2593 1.39964C7.62232 1.1358 6.93961 1 6.25015 1C5.56069 1 4.87798 1.1358 4.24101 1.39964C3.60403 1.66349 3.02526 2.05021 2.53773 2.53773C1.55314 3.52233 1 4.85772 1 6.25015C1 7.64258 1.55314 8.97797 2.53773 9.96257C3.52233 10.9472 4.85772 11.5003 6.25015 11.5003C7.64258 11.5003 8.97797 10.9472 9.96257 9.96257Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <input
              type="text"
              placeholder="Project Name / Project Code / Client Name"
              className="search-input"
              value={search1}
              onChange={(e) => setSearch1(e.target.value)}
            />
          </div>
          {/* <button onClick={() => exportToExcel(filteredData)} className="export-btn">
            Export to Excel
          </button> */}
          <button
            title="Download"
            onClick={() => exportToExcel(filteredData)}
            className="model-button font-weight500   model-button-print">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="22"
              id="download"
              fill="#fff">
              <g
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2">
                <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
              </g>
            </svg>
          </button>


          <div className="action-buttons">
            {/* <AddProjectDetails getDetailsdesign={getProjectdata(toggleState)} /> */}
            <AddProjectDetails getDetailsdesign={() => getProjectdata(toggleState)} />
            <button title="Bulk Upload Projects" class="common-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path></g></svg>
              {/* <BulkUploadProject getProject={getProjectdata} /> */}
              <BulkUploadProject getProject={() => getProjectdata(toggleState)} />
            </button>
          </div>

        </div>

        <div style={{ display: 'flex', alignItems: 'center', borderRadius: '16px', backgroundColor: '#ffffff', gap: '24px', boxSizing: 'border-box', padding: '16px', marginBottom: '16px' }} >
          {statuses.map((status, index) => (
            <div key={status} onClick={() => handleBoxClick(status)} style={{ fontWeight: 500, cursor: 'pointer', borderBottom: activeStatus === status ? '2px solid #2576bc' : '0px' }}>
              {capitalize(status)}: {status === 'allproject' ? filteredData.length : filteredData.filter((data) => data.project_status === status).length}</div>

          ))}

        </div>

        <div class="table-container">
          <div >
            <table className="project-table">
              <thead className="table-heading">
                <tr className="custom-table-head-tr">
                  <th className=" table-heading-text">Sr no.</th>
                  <th className=" table-heading-text">Project Code</th>
                  <th className=" table-heading-text">Project Name</th>
                  {/* <th className=" table-heading-text">Description</th> */}
                  <th className=" table-heading-text">Weightage</th>
                  <th className=" table-heading-text">Total Amoumt</th>
                  <th className=" table-heading-text">Client Name</th>
                  <th className=" table-heading-text">Client POS</th>
                  <th className=" table-heading-text" style={{ position: "relative" }}>Award Date <span ref={menuRefrecieve}>
                    {sortConfig.awardDate === 'asc' &&

                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 9L12 15L6 9" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" onClick={toggleAwardDateSort} />
                      </svg>
                    }
                    {sortConfig.awardDate === 'desc' && ' ↓'}
                  </span>


                  </th>
                  <th className=" table-heading-text" style={{ position: "relative" }}>Start Date <span ref={menuRefstart}>
                    {sortConfig.startDate === 'asc' &&
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 9L12 15L6 9" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" onClick={toggleStartDateSort} />
                      </svg>
                    }
                    {sortConfig.startDate === 'desc' && ' ↓'}
                  </span>


                  </th>

                  <th className="  table-heading-text">Status</th>
                  <th className="  table-heading-text">Project Detail</th>
                  <th className="  table-heading-text" style={{ textAlign: 'center' }}>Actions</th>


                </tr>
              </thead>
              {buffer ? <div className="spinner-small"></div> :

                <tbody>
                  {filteredData
                    .filter((i) =>
                      activeStatus === 'allproject' ? true : i.project_status?.toLowerCase() === activeStatus?.toLowerCase()
                    )
                    .map((i, index) => (
                      <React.Fragment key={index}>

                        <tr className="custom-table-head-td" >
                          <td className="table-body">{index < 9 ? `0${index + 1}` : index + 1}</td>
                          <td className="table-body project-name underline">{i.project_code}</td>
                          <td className="table-body" style={{ textAlign: "left" }}>
                            <span className="project-name underline" onClick={(e) => {
                              e.preventDefault()
                              getProjectdetails(i.id)
                            }}>{i.project_name}</span>
                            <div className="project-name-bar-container">

                              <div className="progress-wrapper">
                                <div className="progress-per" style={{ width: "20%" }}></div>
                              </div>
                              <span className="percentage-label">20%</span>
                            </div>
                          </td>
                          {/* <td className="table-body word-break-outer"><p className="word-break-css">{i.project_description}</p></td> */}
                          <td className="table-body">100%</td>
                          <td className="table-body">{i.woamount}</td>
                          <td className="table-body">{i.clientname || "N/A"}</td>
                          <td className="table-body">{i.client_pos}</td>
                          <td className="table-body">{i.wo_date}</td>
                          <td className="table-body">{i.start_date}</td>
                          <td className="table-body">{i.project_status}</td>
                          <td className="table-body">
                            <span className="action-menu-dropdown-button">
                              <Link onClick={(e) => {
                                e.preventDefault()
                                getProjectdetails(i.id)
                              }} >
                                View
                              </Link>
                            </span>
                          </td>

                          <td className="table-body">
                            <div className="action-menu-container" ref={menuRef}>
                              {/* <Updateprojectdata i={i} getJobappdata={getProjectdata} /> */}
                              <DetailsdesignDelete i={i} getJobappdata={getProjectdata} />
                            </div>
                          </td>


                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>

              }
            </table>
          </div>
        </div>

      </div >
    </>
  );
};

export default AllProjectDetails;
